import { render, staticRenderFns } from "./WakeupSettings.vue?vue&type=template&id=fb77cd4c&scoped=true&"
import script from "./WakeupSettings.vue?vue&type=script&lang=js&"
export * from "./WakeupSettings.vue?vue&type=script&lang=js&"
import style0 from "./WakeupSettings.vue?vue&type=style&index=0&id=fb77cd4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb77cd4c",
  null
  
)

export default component.exports